import { PlatformSDKShape } from '../PlatformSDKShape';
import { BaseSDKShape } from '../BaseSDKShape';

export class PreferencesSDKShape extends BaseSDKShape {
  async get(keys: string[]) {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.userPreferences.get(
      await this.getAppDefinitionId(),
      keys,
    );
  }

  async set(preferences: Record<string, any>) {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.userPreferences.set(
      await this.getAppDefinitionId(),
      preferences,
    );
  }
}

export default new PlatformSDKShape(PreferencesSDKShape)
  .withPublicMethod('set')
  .withPublicMethod('get')
  .build();
